/* global axios */

import ApiClient from './ApiClient';

class CustomRolesAPI extends ApiClient {
  constructor() {
    super('custom_roles', { accountScoped: true });
  }

  // O catálogo vem do servidor (`CustomRole::PERMISSIONS`) em vez de uma lista repetida aqui:
  // permissão nova no Ruby e esquecida no JS seria uma permissão que a policy respeita e a tela
  // nunca oferece, então ninguém conseguiria conceder.
  availablePermissions() {
    return axios.get(`${this.url}/available_permissions`);
  }
}

export default new CustomRolesAPI();
